module.exports = __webpack_public_path__ + "img/firma.60121173.png";